import React from 'react'
import { lower } from 'change-case'
import { connect } from 'react-redux'
import { getFormValues, Field, change } from 'redux-form'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { FileUploadCell } from 'components'
import { selectAttachmentGroup } from '../../AttributeData'

import { AttachmentFormContainer, FieldFileInput } from './styled'

const FieldAttachment = props => {
  const {
    //preops
    requireMemo=false, 
    //state
    valueForm 
  } = props
  
  if(valueForm){
    var countAttachLine = null
    var vendorCode = valueForm.goodsServiceReceiptPOs[0]?valueForm.goodsServiceReceiptPOs[0].vendorCode:0
    var documentTypesFilter = selectAttachmentGroup(valueForm.mainDeliveryType,valueForm.subDeliveryType,props.grType.data,vendorCode,valueForm.isFromVendor)
    countAttachLine = Array(Math.ceil(documentTypesFilter.length / 3)).fill(1)
  }

  return (
    <React.Fragment>
      {countAttachLine&&countAttachLine.map((v, i1) => {
        return (
          <AttachmentFormContainer key={i1}>
            {documentTypesFilter.map((dt, i2) => {
              if (Math.floor(i2 / 3) === i1) {
                return (
                  <FieldFileInput className='fieldFileInput' key={i2}>
                    <Field
                      name={lower(dt.code)}
                      label={dt.name}
                      require={lower(dt.code)=='gr07'?requireMemo:dt.isRequire}
                      type={type.file}
                      component={FieldInput}
                      containerStyle={{ marginRight: 0 }}
                    />
                    <div style={{ flex: 1 }}>
                      {valueForm.goodsServiceReceiptAttachments
                        ? valueForm.goodsServiceReceiptAttachments.filter( x => x.documentCode.toLowerCase() === dt.code.toLowerCase() && !x.deleted ).map((item, i3) => (
                              <div className='oldFile'><FileUploadCell
                                key={`${item.originalFilename}${i3}`}
                                fileName={item.originalFilename}
                                fileSize={item.size}
                                deleted={item.deleted}
                                deletable={!item.isFromVendor}
                                urlPath={item.urlPath}
                                onClickDelete={() => {
                                  let index = valueForm.goodsServiceReceiptAttachments.findIndex(x => x.id === item.id)
                                  props.dispatch(change('formGR',`goodsServiceReceiptAttachments[${index}].deleted`,true))
                                }}
                              /></div>
                            ))
                        : null}
                    </div>
                  </FieldFileInput>
                )
              } else {
                return null
              }
            })}
          </AttachmentFormContainer>
        )
      })}
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const valueForm = getFormValues('formGR')(state)
  return {
    grType: state.gr.grType,
    valueForm
  }
}

const mapDispatchToProps = (dispatch) =>({
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(FieldAttachment)
